// src/mixins/clickMixin.js
import moment from "moment";

export default {
    methods: {
        getFormattedNumber(number)  {
            if (number < 9) {
                return '00' + number;
            } else if (number < 99) {
                return '0' + number;
            } else {
                return number;
            }
        },
        /**
         * Get an ISO formatted date in form of a string
         */
        getFormattedDate(date) {
            return !date ? null : moment(date).format('YYYY-MM-DD');
        }
    }
};